const { AUTH_ACTIONS, AUTH_ALL_ACTIONS } = require('./constants');

const authPermissions = (action, permissions, institutionId) => {
  if (
    action.startsWith('auth:') &&
    permissions[institutionId].includes('ADMIN_UI_DEVELOPER')
  ) {
    return true;
  }

  if (
    AUTH_ALL_ACTIONS.some((authAction) => action.includes(authAction)) &&
    permissions[institutionId].includes('ADMIN_UI_ALL_ORG_MANAGEMENT')
  ) {
    return true;
  }

  if (
    AUTH_ACTIONS.some((authAction) => action.includes(authAction)) &&
    permissions[institutionId].includes('ADMIN_UI_ORG_MANAGEMENT')
  ) {
    return true;
  }

  return false;
};

module.exports = {
  authPermissions,
};
